/**
 * Symbol Picker Component
 * 
 * Side panel with symbols, emojis, and icons that can be inserted into plate text.
 */

interface SymbolPickerProps {
  onSymbolClick: (symbol: string) => void
}

const EMOJIS = ['❤️', '⭐', '🚗', '⚡', '🔥', '😎', '🎁', '💍', '👑', '🎉', '💖', '🌟', '🏆', '💎', '🎯']
const SYMBOLS = ['•', '★', '☆', '♥', '♛', '✿', '❀', '✧', '✦', '✩', '✪', '✫', '✬', '✭', '✮']

const SymbolPicker = ({ onSymbolClick }: SymbolPickerProps) => {
  return (
    <div className="bg-dark-800 rounded-xl p-4 border border-gray-700">
      <h4 className="text-sm font-semibold text-gray-300 mb-3">Symbole & Emojis</h4>
      
      <div className="space-y-4">
        {/* Emojis */}
        <div>
          <label className="block text-xs text-gray-400 mb-2">Emojis</label>
          <div className="grid grid-cols-5 gap-2">
            {EMOJIS.map((emoji, i) => (
              <button
                key={i}
                onClick={() => onSymbolClick(emoji)}
                className="p-2 bg-dark-700 hover:bg-dark-600 rounded-lg text-2xl transition-colors hover:scale-110"
                title={emoji}
              >
                {emoji}
              </button>
            ))}
          </div>
        </div>

        {/* Symbols */}
        <div>
          <label className="block text-xs text-gray-400 mb-2">Symbole</label>
          <div className="grid grid-cols-5 gap-2">
            {SYMBOLS.map((symbol, i) => (
              <button
                key={i}
                onClick={() => onSymbolClick(symbol)}
                className="p-2 bg-dark-700 hover:bg-dark-600 rounded-lg text-xl font-bold transition-colors hover:scale-110"
                style={{ color: '#FFD700' }}
                title={symbol}
              >
                {symbol}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default SymbolPicker
